module.exports = __webpack_public_path__ + "static/media/1A.2a7468ec.jpg";